import type { CSSProperties } from 'react';

/**
 * Multi-layer background for the My Packs photo container. Layer 1 is
 * an optional image (covers + centred, falls through to `none` when no
 * URL is set); Layer 2 is the gradient (top → bottom, defaults to the
 * same colour in both stops so an un-overridden surface renders as a
 * solid tint).
 *
 * Two namespaces because MyPacks shows two visually-similar tiles that
 * partners style independently:
 *   • `MyPacksItemCard.photoBg*`     — Cards tab (OpenedItemCard photo).
 *   • `MyPacksDeliveryCard.photoBg*` — Deliveries tab preview area.
 *
 * Each constant is a STATIC literal (no template assembly) so the
 * theme-constructor's schema-invariant regex scanner can prove each
 * registry knob is actually consumed in code.
 */
export const PHOTO_BG_STYLE: CSSProperties = {
  backgroundImage:
    'var(--co-MyPacksItemCard-photoBgImage, none), ' +
    'linear-gradient(to bottom, ' +
    'var(--co-MyPacksItemCard-photoBgFrom, rgba(255,255,255,0.03)) 0%, ' +
    'var(--co-MyPacksItemCard-photoBgTo, rgba(255,255,255,0.03)) 100%)',
  backgroundSize: 'cover, auto',
  backgroundPosition: 'center, top',
  backgroundRepeat: 'no-repeat, no-repeat',
};

export const PHOTO_BG_STYLE_DELIVERY: CSSProperties = {
  backgroundImage:
    'var(--co-MyPacksDeliveryCard-photoBgImage, none), ' +
    'linear-gradient(to bottom, ' +
    'var(--co-MyPacksDeliveryCard-photoBgFrom, rgba(255,255,255,0.03)) 0%, ' +
    'var(--co-MyPacksDeliveryCard-photoBgTo, rgba(255,255,255,0.03)) 100%)',
  backgroundSize: 'cover, auto',
  backgroundPosition: 'center, top',
  backgroundRepeat: 'no-repeat, no-repeat',
};
